import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';
import { deleteDocumentType } from '../../../../actions';

const DocumentTypeDeleteButton = ({
  dispatchDeleteDocumentType,
  documentTypeId,
  disabled,
}) => {
  const [showModal, setShowModal] = useState(false);

  const onClickDelete = () => dispatchDeleteDocumentType({ documentTypeId });

  const openModal = () => setShowModal(true);

  const closeModal = () => setShowModal(false);

  return (
    <>
      <ConfirmationModal
        show={showModal}
        onClickConfirm={onClickDelete}
        onClickCancel={closeModal}
      />
      <Button color="danger" onClick={openModal} disabled={disabled}>
        <i className="fa fa-trash-o" /> Eliminar
      </Button>
    </>
  );
};

DocumentTypeDeleteButton.propTypes = {
  dispatchDeleteDocumentType: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  documentTypeId: PropTypes.number.isRequired,
};

DocumentTypeDeleteButton.defaultProps = {
  disabled: false,
};

const mapDispatchToProps = {
  dispatchDeleteDocumentType: deleteDocumentType,
};

export default connect(null, mapDispatchToProps)(DocumentTypeDeleteButton);
